module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-reels-07c2eec0.svg";